import storageRef from "../firebase/storage";

export function uuidv4() {
	return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
		const r = (Math.random() * 16) | 0,
			v = c === "x" ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	});
}

export async function uploadImage(file, folder, progress = () => {}) {
	const metadata = {
		contentType: file.type,
	};

	const randomName = uuidv4();

	const fileFinal = `${folder}/${randomName}${file.name}`;
	const uploadTask = storageRef.child(fileFinal).put(file, metadata);
	return new Promise((resolve, reject) => {
		uploadTask.on(
			"state_changed",
			function (snapshot) {
				const progressValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
				progress(`Subiendo imagen ${file.name}`, progressValue);
			},
			function (error) {
				reject(error);
			},
			function () {
				uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
					progress(100);
					const data = { ref: fileFinal, url: downloadURL };
					resolve(data);
				});
			}
		);
	});
}

export function removeImage(reference) {
	const ref = storageRef.child(reference);
	return new Promise((resolve, reject) => {
		ref
			.delete()
			.then(function () {
				console.log(`Se elimino ${reference}`);
				resolve("SUCCESS");
			})
			.catch(function (error) {
				reject(error);
			});
	});
}
